import React, { FunctionComponent, useState } from 'react'

import styled from 'styled-components/native'

import { FilterButtonModal, FilterOptions } from './FilterButtonModal'
import { BaseModal } from '../../organisms/baseModal/BaseModal'
import { tID } from '../../utils/utils'
import { PrimaryButton } from '../primaryButton/PrimaryButton'

const Container = styled.View({
  marginRight: 8,
  marginBottom: 8,
})

export interface FilterButtonProps {
  filterName: string
  filterOptions: FilterOptions
  filterArray: Array<string>
  saveOnClick: (filterArray: Array<string>) => void
}

export const FilterButton: FunctionComponent<FilterButtonProps> = ({
  filterName,
  filterOptions,
  filterArray,
  saveOnClick,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = () => setIsModalOpen(false)

  const modalBody = (
    <FilterButtonModal
      filterName={filterName}
      filterOptions={filterOptions}
      filterArray={filterArray}
      saveOnClick={saveOnClick}
      closeModal={closeModal}
    />
  )

  return (
    <Container testID={tID('FilterButton')}>
      <PrimaryButton
        text={filterName}
        onPress={() => setIsModalOpen(true)}
        testID={tID(`FilterButton-${filterName}`)}
      />
      <BaseModal isOpen={isModalOpen} body={modalBody} closeModal={closeModal} />
    </Container>
  )
}

export default FilterButton
